import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { PaymentRequired as PaymentRequiredComponent } from '../components/subscription/PaymentRequired';
import { Seo } from '../components/Seo';
import { useSubscription } from '../hooks/useSubscription';
import { Brand } from '../components/common/Brand';

export const PaymentRequired: React.FC = () => {
  const { user, loading } = useAuth();
  const { status } = useSubscription();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !user) {
      navigate('/login');
    }
  }, [user, loading, navigate]);

  useEffect(() => {
    // If payment is not required, redirect to dashboard
    if (status && !status.payment_required) {
      navigate('/dashboard');
    }
  }, [status, navigate]);

  if (loading) {
    return (
      <div className="auth auth-center">
        <div className="auth-card">
          <div className="auth-brand"><Brand variant="full" height={64} /></div>
          <h1 className="auth-title">Loading…</h1>
          <p className="auth-sub">Checking your subscription status.</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return null;
  }

  return (
    <>
      <Seo title="Upgrade to Pro — Local Area Cloud" description="Upgrade your Local Area Cloud account to Pro." path="/payment-required" noindex />
      <PaymentRequiredComponent />
    </>
  );
};





